import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/react-query';
import { Team } from '@/types';

export const getUserTeams = (): Promise<Team[]> => {
  return api.get(`/users/teams`, {
    withCredentials: true,
  });
};

export const getUserTeamsQueryOptions = () => {
  return queryOptions({
    queryKey: ['users', 'teams'],
    queryFn: getUserTeams,
  });
};

type useUserTeamsOptions = {
  queryConfig?: QueryConfig<typeof getUserTeamsQueryOptions>;
};

export const useUserTeams = ({ queryConfig }: useUserTeamsOptions = {}) => {
  return useQuery({
    ...getUserTeamsQueryOptions(),
    ...queryConfig,
  });
};
